import React, { useState, useEffect } from 'react';


export default function useLocalStorage(init, key) {
  const [ memState, setMemState ] = useState(init);
  
  // init from storage at mount
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem(key));
    if (data) {
      setMemState(data);
    }
  }, []);

  // save to storage on change
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(memState));
  }, [memState]);

  return [ memState, setMemState ];
}
